import { createElementBlock as t, openBlock as c, createElementVNode as e } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 27 21"
};
function o(r, l) {
  return c(), t("svg", n, [...l[0] || (l[0] = [
    e("path", {
      fill: "#1A1F71",
      d: "M27 17.645c0 .53-.446.955-1.004.955H1.004C.446 18.6 0 18.175 0 17.645V3.355c0-.53.446-.955 1.004-.955h24.992c.558 0 1.004.424 1.004.955z"
    }, null, -1),
    e("path", {
      fill: "#fff",
      d: "m10.265 7.104-3.013 6.827h-1.97L3.792 8.484c-.074-.319-.185-.46-.446-.602a7.8 7.8 0 0 0-1.822-.566l.037-.212h3.161c.41 0 .781.248.856.708l.78 3.961L8.295 7.14h1.97zm7.698 4.598c0-1.804-2.603-1.91-2.603-2.688 0-.247.26-.495.78-.566a3.4 3.4 0 0 1 1.823.319l.335-1.45c-.447-.142-1.004-.319-1.748-.319-1.823 0-3.124.92-3.124 2.264 0 .99.93 1.52 1.636 1.84.707.317.967.53.967.848 0 .46-.558.672-1.116.672-.93 0-1.487-.248-1.896-.424l-.335 1.485c.446.177 1.227.354 2.045.354 1.934 0 3.199-.92 3.236-2.335m4.835 2.229h1.71l-1.487-6.827h-1.6c-.371 0-.669.212-.78.495l-2.79 6.332h1.934l.372-1.026h2.38zm-2.083-2.405.967-2.547.558 2.547zm-7.81-4.422-1.525 6.827H9.52l1.526-6.827z"
    }, null, -1)
  ])]);
}
const m = { render: o };
export {
  m as default,
  o as render
};
